export function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export function onFullyLoaded(fn) {
    window.addEventListener('load', function () {
        fn();
    })
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}

export function hide(el) {
    el.style.display = 'none';
}

export function show(el, display = 'block') {
    el.style.display = display;
}

export function parents(el, tag) {
  let current = el;

  while (current) {
    if (current.nodeName === tag) {
      return current;
    } else if (current.nodeName === 'BODY') {
      return undefined;
    }

    current = current.parentElement;
  }

  return undefined;
}

export function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function getWindowWidth() {
    return window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
}

export function getWindowHeight() {
    return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
}
